




























































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TbReport, TbGoodsClass, TbGoods, TbOrderPad } from "@/http";
import { calendarPanel, NumberKeyboard,logoutPanel } from "@/components";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { fmoney } from "@/common/util/money";
import calculate from "@/common/util/calculate";
import goodsjydetail from "./goodsjydetail.vue";
dayjs.locale("zh-cn");
@Component({
  components: {
    calendarPanel,
    NumberKeyboard,
    goodsjydetail,
    logoutPanel
  },
})
export default class goodsbb extends Vue {
  public $refs: {
    goodsjydetail: HTMLFormElement;
    barcode:HTMLFormElement;
  };
  @Prop({
      default:''
  })
  start:string;
  @Prop({
      default:''
  })
  end:string;
  @Prop({
      default:'1'
  })
  curZLStr:string;

  curZL = 1;
  fmoney = fmoney;
  /**查询项- */
  searchValue1 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    name: "",
    goodsClassId: "",
    startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    sort: 1,
    skip: 0,
    count: 10,
  };
  searchValue2 = {
    shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
    type: 6,
    start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
    end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
    skip: 0,
    count: 10,
  };
  /**时间类型下拉 */
  showStatusPopover = false;
  payType = null;
  showClassPopover = false;
  classList = [];

  /**时间控件 */
  pickerShow = false;
  startDate = dayjs(new Date()).format("YYYY-MM-DD");
  endDate = dayjs(new Date()).format("YYYY-MM-DD");

  /**列表展示
   * 1:图
   * 2：表格
   */
  showType = 1;

  userInfo: any = {};

  /**列表加载相关 */
  refreshing = false;
  loading = false;
  finished = false;
  list = [];
  list2 = [];
  list3 = [];
  total = 0;
  currentPage = 1;
  totalStock = 0;

  timeActive = null;
  hj_ze = "0.00";
  hj_xsnum = 0;
  hj_the = "0.00";
  hj_sxze = "0.00";
  hj_zkze = "0.00";
  hj_xykc = 0;

  returnTotal= "0.00";
  returnNums= 0;
  iscz = false;

  /**提示弹窗 */
  tipShow= false;
  tipTitle="";
  tipText="";
  confirmText="";
  cancelText="";
  btnNums=1;
  tipType=1;
  tipDatashow=false;

  get className() {
    let str = "";
    if (this.searchValue1.goodsClassId) {
      str = this.classList.some((v) => v.id == this.searchValue1.goodsClassId)
        ? this.classList.find((v) => v.id == this.searchValue1.goodsClassId).name
        : "";
    } else {
      str = "全部分类";
    }
    return str;
  }

  @Watch("searchValue1.name")
  nameChange(val) {
    if (!this.iscz) {
      this.getList();
    }
  }
  created() {
    if(this.curZLStr){
	  		  this.curZL=Number(this.curZLStr);
	  }
    if(this.start){
	  		  if(this.curZL==1){
	  			  this.searchValue1.startTime = this.start;
	  			  this.searchValue1.endTime = this.end;
	  		  }else if(this.curZL==2){
	  			  this.searchValue2.start = this.start;
	  			  this.searchValue2.end = this.end;
	  		  }
	  	this.startDate = dayjs(this.start).format("YYYY-MM-DD");
	  	this.endDate = dayjs(this.end).format("YYYY-MM-DD");
	  	// this.defaultDate = [this.startDate,this.endDate]
	  }
  }

  async mounted() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    this.getClassList();

    this.getInputFocus()
      document.addEventListener('click',this.chargeInputFocus)
  }

  async scanInput(val){
        let res = await TbGoods.GetTbGoodsByBarCode({barCode:val});
        if(res.getGoodsItemsList&&res.getGoodsItemsList.length>0){
            this.searchValue1.name = res.barCode?res.barCode:'';
        }
    }
    getInputFocus(){
        this.$nextTick(()=>{
            this.$refs['barcode'].select()
            document.addEventListener('keydown', this.handleScanCode)
        })
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {
          this.getInputFocus()

        }
    }
    beforeDestroy() {
        document.removeEventListener('keydown',this.handleScanCode) //离开当前路由，会直接调用beforeDestroy方法销毁回车事件
        document.removeEventListener('click', this.chargeInputFocus)
    }
    public scanCodes:any = ''
   /**
     * 监听扫码枪输入
     */
    async handleScanCode(event) {
        if (event.key === 'Backspace' || event.keyCode === 8) {
        // 允许退格键的默认行为
        return;
        }
        console.log('14',event.target.value)
        if(this.isFocus){
            this.searchValue1.name = event.target.value
        }else{
            if (event.key === 'Enter' || event.keyCode == 13) {
                let code = this.scanCodes?this.scanCodes:event.target.value
                this.scanInput(code)
                this.scanCodes = ''
            return
            }
        }

    }
    isFocus = false
    getFocus(){
        this.isFocus = true
    }
    inputBlur(){
        this.isFocus = false
        document.addEventListener('click',this.chargeInputFocus)

    }

  /**获取分类下拉 */
  async getClassList() {
    let res = await TbGoodsClass.GetAllGoodsClassList({ needGoodsCount: true });
    this.classList = res;
  }

  async chooseClass(id) {
    this.searchValue1.goodsClassId = id;
    this.showClassPopover = false;
    this.iscz = false;
    await this.getList();
  }

  openselDate() {
    this.pickerShow = true;
  }
  /**确定选择时间 */
  onselConfirm(date) {
    const [start, end] = date;
    this.startDate = dayjs(start).format("YYYY-MM-DD");
    this.endDate = dayjs(end).format("YYYY-MM-DD");

    this.pickerShow = false;
    this.timeActive = null;
    this.setTimeSearch();
  }
  closeTime() {
    this.pickerShow = false;
  }

  /**下拉刷新 */
  onRefresh() {
    // 清空列表数据
    this.finished = false;
    // 重新加载数据
    // 将 loading 设置为 true，表示处于加载状态
    this.loading = true;
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : "searchValue1";
    this[arg].skip = 0;
    this[arg].count = 10;
    this.currentPage = 1;
    this.loadMore();
  }
  /**触底加载 */
  async loadMore() {
    let arg =
      this.curZL == 1
        ? "searchValue1"
        : this.curZL == 2
        ? "searchValue2"
        : this.curZL == 3
        ? "searchValue3"
        : "searchValue1";
    let arg2 =
      this.curZL == 1
        ? "list"
        : this.curZL == 2
        ? "list2"
        : this.curZL == 3
        ? "list3"
        : "list";
    if (this.refreshing) {
      this[arg2] = [];
      this.refreshing = false;
    }
    let s = this[arg].count;
    switch (this.curZL) {
      // 商品报表
      case 1:
        let resjy = await TbReport.GetOrderItemReport(Object.assign({}, this[arg]));
        let resjy2 = await TbReport.GetOrderItemTotal(Object.assign({}, this[arg]));
        this.list = this[arg].skip == 0 ? resjy.items : this.list.concat(resjy.items);
        this.total = resjy.totalCount;
        this.hj_ze = resjy2.totalNum;
        this.hj_sxze = fmoney(resjy2.salesTotal, 2);
        this.hj_xsnum = resjy2.returnNum;
        this.hj_zkze = fmoney(resjy2.returnTotal, 2);
        this.hj_xykc = resjy2.stock;
        this.iscz = false;
        break;
      // 退货订单
        case 2:
          let resth = await TbOrderPad.GetReturnGoodsDetailOperatePad(Object.assign({}, this[arg]));
          let resth2 = await TbOrderPad.GetReturnGoodsDetailOperateTotalPad(Object.assign({}, this[arg]));
          this.list2 = this[arg].skip == 0 ? resth.items : this.list2.concat(resth.items);
          this.total = resth.totalCount;
          this.returnTotal = fmoney(resth2.returnAmount);
			    this.returnNums = resth2.returnNum;
          this.iscz = false;
          break;
      default:
        break;
    }
    this.currentPage++;
    this[arg].skip = (this.currentPage - 1) * s;
    this.loading = false;
    if (this[arg2].length >= this.total) {
      this.finished = true;
    }
  }
  /**获取商品列表 */
  async getList() {
    this.onRefresh();
  }
  /**重置 */
  resetSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          name: "",
          goodsClassId: "",
          startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          sort: 1,
          skip: 0,
          count: 10,
        };
        break;
      case 2:
        this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
          type: 6,
          start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
          end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
          skip: 0,
          count: 10,
        };
        break;
      default:
        break;
    }
    this.payType = null;
    this.timeActive = null;
    this.showClassPopover = false;
    this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
    this.iscz = true;
    this.getList();
  }
  async sortFun(val) {
    if (this.curZL == 1) {
      switch (val) {
        case 1:
          this.searchValue1.sort == 1
            ? (this.searchValue1.sort = 2)
            : (this.searchValue1.sort = 1);
          break;
        case 2:
          this.searchValue1.sort == 3
            ? (this.searchValue1.sort = 4)
            : (this.searchValue1.sort = 3);
          break;
        case 3:
          this.searchValue1.sort == 5
            ? (this.searchValue1.sort = 6)
            : (this.searchValue1.sort = 5);
          break;
        case 4:
          this.searchValue1.sort == 7
            ? (this.searchValue1.sort = 8)
            : (this.searchValue1.sort = 7);
          break;
        case 5:
          this.searchValue1.sort == 9
            ? (this.searchValue1.sort = 10)
            : (this.searchValue1.sort = 9);
          break;
        default:
          break;
      }
    }
    this.iscz = false;
    await this.getList();
  }
  async chooseTime(type) {
    this.timeActive = type;
    // 获取当前日期
    const today = dayjs();
    const firstDayOfWeek = dayjs().startOf("week");
    const firstDayOfMonth = dayjs().startOf("month");
    const prevMonthStart = today.subtract(1, "month").startOf("month");
    const prevMonthEnd = today.subtract(1, "month").endOf("month");
    switch (type) {
      case 1:
        this.startDate = today.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 2:
        this.startDate = firstDayOfWeek.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 3:
        this.startDate = firstDayOfMonth.format("YYYY-MM-DD");
        this.endDate = today.format("YYYY-MM-DD");
        break;
      case 4:
        this.startDate = prevMonthStart.format("YYYY-MM-DD");
        this.endDate = prevMonthEnd.format("YYYY-MM-DD");
        break;

      default:
        break;
    }
    await this.setTimeSearch();
  }
  async setTimeSearch() {
    switch (this.curZL) {
      case 1:
        this.searchValue1.startTime = this.startDate ? this.startDate + " 00:00:00" : "";
        this.searchValue1.endTime = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      case 2:
        this.searchValue2.start = this.startDate ? this.startDate + " 00:00:00" : "";
          this.searchValue2.end = this.endDate ? this.endDate + " 23:59:59" : "";
        break;
      default:
        break;
    }
    this.iscz = false;
    await this.getList();
  }
  viewdetail(item) {
    if(item.isDelete){
			this.tipTitle = "操作提醒";
			this.tipText = `该商品不存在或已删除`;
			this.btnNums=1;
			this.confirmText = "我知道了";
			this.tipType=1;
			this.tipShow=true;
			return;
		}
    this.$refs.goodsjydetail.showFun(
      item,
      this.searchValue1.startTime,
      this.searchValue1.endTime
    );
  }

  clearSearch() {
		switch (this.curZL) {
			case 1:
				this.searchValue1 = {
				  shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
				  name: "",
				  goodsClassId: "",
				  startTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
				  endTime: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
				  sort: 1,
				  skip: 0,
				  count: 10,
				};
				break;
			case 2:
				this.searchValue2 = {
          shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,					type: 6,
					start: dayjs(new Date()).format("YYYY-MM-DD") + " " + "00:00:00",
					end: dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59",
					skip: 0,
					count: 10,
				};
				break;
			default:
				break;
		}
		this.timeActive = null;
		this.startDate = dayjs(new Date()).format("YYYY-MM-DD");
		this.endDate = dayjs(new Date()).format("YYYY-MM-DD");
	}
	chooseZL(tag) {
		this.curZL = tag;
		this.clearSearch();
		this.iscz = true;
		this.getList();

	}
	/**提示弹窗 */
	async tipConfirm(){
	    switch (this.tipType) {
	        case 1:

	            break;


	        default:
	            break;
	    }
	    this.tipShow = false;
	}

	tipCancel(){
	    this.tipShow = false;
	}
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/report/components/goodsbb.vue